import React from 'react';

import { Accordion } from '../../common/Accordion';

import { Footer } from './components/Footer';
import { Navbar } from './components/Navbar';
import { ABOUT_US_CONSTANTS } from './constants';

export function AboutUs(): JSX.Element {
  return (
    <div className="flex flex-col w-full min-h-screen">
      <Navbar />

      {/* Main content */}
      <div className="flex-1 bg-white">
        <div className="max-w-screen-xl mx-auto py-12 px-6">
          {/* Hero section */}
          <div className="mb-12 text-center">
            <h1 className="text-3xl font-nunito font-bold mb-4 text-gray-900">
              {ABOUT_US_CONSTANTS.TITLE}
            </h1>
            <p className="text-xl max-w-2xl mx-auto text-gray-700">
              {ABOUT_US_CONSTANTS.SUBTITLE}
            </p>
          </div>

          <div className="space-y-4 max-w-screen-s m:max-w-screen-m mx-auto">
            <Accordion
              title={ABOUT_US_CONSTANTS.SECTIONS.WHAT_IS.TITLE}
              defaultOpen
              className="bg-[#FDFAF8]"
            >
              <div className="p-6 bg-white rounded-lg">
                {ABOUT_US_CONSTANTS.SECTIONS.WHAT_IS.CONTENT.map(
                  (paragraph, index) => (
                    <p
                      key={`what-is-paragraph-${paragraph.slice(0, 20)}`}
                      className={
                        index <
                        ABOUT_US_CONSTANTS.SECTIONS.WHAT_IS.CONTENT.length - 1
                          ? 'mb-4'
                          : ''
                      }
                    >
                      {paragraph}
                    </p>
                  ),
                )}
              </div>
            </Accordion>

            <Accordion
              title={ABOUT_US_CONSTANTS.SECTIONS.VISION.TITLE}
              className="bg-[#FDFAF8]"
            >
              <div className="p-6 bg-white rounded-lg">
                {ABOUT_US_CONSTANTS.SECTIONS.VISION.CONTENT.map(
                  (paragraph, _index) => (
                    <p
                      key={`vision-paragraph-${paragraph.slice(0, 20)}`}
                      className="mb-4"
                    >
                      {paragraph}
                    </p>
                  ),
                )}
                <ul className="list-disc pl-5 space-y-2 mb-4">
                  {ABOUT_US_CONSTANTS.SECTIONS.VISION.BULLET_POINTS.map(
                    (point) => (
                      <li key={`vision-point-${point.slice(0, 20)}`}>
                        {point}
                      </li>
                    ),
                  )}
                </ul>
                <p>{ABOUT_US_CONSTANTS.SECTIONS.VISION.CONCLUSION}</p>
              </div>
            </Accordion>

            <Accordion
              title={ABOUT_US_CONSTANTS.SECTIONS.BENEFITS.TITLE}
              className="bg-[#FDFAF8]"
            >
              <div className="p-6 bg-white rounded-lg">
                <ul className="list-disc pl-5 space-y-2">
                  {ABOUT_US_CONSTANTS.SECTIONS.BENEFITS.BULLET_POINTS.map(
                    (point) => (
                      <li key={`benefit-point-${point.slice(0, 20)}`}>
                        {point}
                      </li>
                    ),
                  )}
                </ul>
              </div>
            </Accordion>

            <Accordion
              title={ABOUT_US_CONSTANTS.SECTIONS.CALENDAR_ACCESS.TITLE}
              className="bg-[#FDFAF8]"
            >
              <div className="p-6 bg-white rounded-lg">
                {ABOUT_US_CONSTANTS.SECTIONS.CALENDAR_ACCESS.CONTENT.map(
                  (paragraph, _index) => (
                    <p
                      key={`calendar-paragraph-${paragraph.slice(0, 20)}`}
                      className="mb-4"
                    >
                      {paragraph}
                    </p>
                  ),
                )}
                <div className="bg-gray-100 p-3 rounded my-4 font-mono text-sm">
                  {ABOUT_US_CONSTANTS.SECTIONS.CALENDAR_ACCESS.SCOPE}
                </div>
                <p className="mb-4">We use this access to:</p>
                <ul className="list-disc pl-5 space-y-2 mb-4">
                  {ABOUT_US_CONSTANTS.SECTIONS.CALENDAR_ACCESS.USES.map(
                    (use) => (
                      <li key={`calendar-use-${use.slice(0, 20)}`}>{use}</li>
                    ),
                  )}
                </ul>
                {ABOUT_US_CONSTANTS.SECTIONS.CALENDAR_ACCESS.DISCLAIMER.map(
                  (paragraph, index) => (
                    <p
                      key={`calendar-disclaimer-${paragraph.slice(0, 20)}`}
                      className={
                        index <
                        ABOUT_US_CONSTANTS.SECTIONS.CALENDAR_ACCESS.DISCLAIMER
                          .length -
                          1
                          ? 'mb-4'
                          : ''
                      }
                    >
                      {paragraph}
                    </p>
                  ),
                )}
              </div>
            </Accordion>

            <Accordion
              title={ABOUT_US_CONSTANTS.SECTIONS.PRIVACY.TITLE}
              className="bg-[#FDFAF8]"
            >
              <div className="p-6 bg-white rounded-lg">
                {ABOUT_US_CONSTANTS.SECTIONS.PRIVACY.CONTENT.map(
                  (paragraph, _index) => (
                    <p
                      key={`privacy-paragraph-${paragraph.slice(0, 20)}`}
                      className="mb-4"
                    >
                      {paragraph}
                    </p>
                  ),
                )}
                <ul className="list-disc pl-5 space-y-2 mb-4">
                  {ABOUT_US_CONSTANTS.SECTIONS.PRIVACY.BULLET_POINTS.map(
                    (point) => (
                      <li key={`privacy-point-${point.slice(0, 20)}`}>
                        {point}
                      </li>
                    ),
                  )}
                </ul>

                <p>
                  For more, please see our{' '}
                  <a
                    href={ABOUT_US_CONSTANTS.LINKS.PRIVACY_POLICY}
                    className="text-blue-600 hover:underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>
                </p>
              </div>
            </Accordion>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default AboutUs;
